import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HOST,VERIFICAR_SI_FUENTE_CHV_PUEDE_REPORTAR_PERIODO, VERIFICAR_SI_FUENTE_FIVI_PUEDE_REPORTAR_PERIODO } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class CarguemasivofuenteService {

  url: string= HOST;

constructor(private http: HttpClient) { }

validarSiFuenteChvPuedeReportarEnPeriodo(idusu, idfte, idperi):Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + VERIFICAR_SI_FUENTE_CHV_PUEDE_REPORTAR_PERIODO + idusu + "/" + idfte + "/" + idperi;
  return this.http.get<any>(direccion, {'headers': header});
}

validarSiFuenteFiviPuedeReportarEnPeriodo(idusu, idfte, idperi):Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + VERIFICAR_SI_FUENTE_FIVI_PUEDE_REPORTAR_PERIODO + idusu + "/" + idfte + "/" + idperi;
  return this.http.get<any>(direccion, {'headers': header});
}

}
